import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Moment from 'moment'

import FullTextPreview from 'components/FilePreview/FullTextPreview'
import ImagePreview from 'components/FilePreview/ImagePreview'
import VideoPreview from 'components/FilePreview/VideoPreview'

import Styles from './index.scss'

const Portfolios = (props) => {
  let previews = (<ImagePreview reference={props.row.portfolio} isBackGround />)
  if (props.row.portfolio.filetype === 'video') {
    previews = (
      <VideoPreview
        portfolio={{
          url: props.row.portfolio.url,
          urlRawFile: props.row.portfolio.urlRawFile,
        }}
        fullPage="fullPage"
      />
    )
  } else if (props.row.portfolio.filetype === 'text') {
    previews = (
      <FullTextPreview
        portfolio={props.row.portfolio}
        rootClassName={`${Styles['preview-only']} text-center ${Styles['portfolio-item']} ${Styles.item} ${Styles.pdf}`}
        documentClassName={Styles['preview-only']}
        pageClassName={`${Styles['preview-only']} ${Styles['canvas-wrapper']}`}
      />
    )
  }
  const sampleTopic = props.topic.map(tags => (
    tags.name
  ))
  return (
    <tr>
      <td> {parseInt(props.skip, 0) + props.indexKey + 1} </td>
      <td> <span>{props.portfolioStatus[props.row.portfolio.status].label} </span></td>
      <td> {Moment(`${props.row.createdAt}`).format('MMMM, DD YYYY')} </td>
      <td> <span className="capitalize">{props.row.portfolio.title} </span></td>
      <td> <span>{sampleTopic.join(', ')} </span></td>
      <td style={{ width: '225px' }}> {previews} </td>
      <td>
        <Link to={`/products/${props.row.product}/portfolio/${props.row.portfolio.id}`} className="btn btn-icon-only red">
          <i className="fa fa-eye" />
        </Link>
      </td>
    </tr>
  )
}

Portfolios.propTypes = {
  row: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    product: PropTypes.string.isRequired,
    portfolio: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      filetype: PropTypes.string.isRequired,
      status: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  topic: PropTypes.arrayOf(PropTypes.object).isRequired,
  portfolioStatus: PropTypes.arrayOf(PropTypes.object).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Portfolios
